import React from "react";
import "../css/About.css";
// import "../css/Services.css"

import Carousel from "react-bootstrap/Carousel";
const Footer = React.lazy(() => import("./Footer"));

const About = () => {
  return (
    <div className="about-container">
      <div className="row">
        <div className="col-sm-12">
          <div className="about-us-container"           
          data-aos="zoom-in-up"
          data-aos-easing="linear"
          data-aos-duration="500">
            <h2 className="about-title">About Us</h2>
            <p className="about-text">
              Founded in Chicago IL, Ingenious Construction has been proudly
              serving the Chicagoland area and Indiana for over 5 years,
              supported by more than 30 years of carpentry experience. Our team
              is dedicated to delivering precision, reliability, and
              long-lasting craftsmanship. From planning through completion, we
              work closely with our clients to ensure every detail matches their
              vision and exceeds expectations.
            </p>
            <div className="store-img-container">
              <img
                src={require("../public/images/chicago.png")}
                className="about-img"
                alt="Chicago under construction"
              ></img>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <h2 className="about-title">Meet the Founder</h2>
          <div className="about-emp-1">
            <img
              src={require("../public/images/tio-pedro-profile-rs.jpg")}
              className="about-1-img"
              alt="Ingenious Construction, Pedro Zavala"
                        
          data-aos="zoom-in-up"
          data-aos-easing="linear"
          data-aos-duration="500"
            ></img>
            <div className="about-1-text-container"           
          data-aos="zoom-in-up"
          data-aos-easing="linear"
          data-aos-duration="800">
              <h2 className="about-1-title">Pedro Zavala</h2>
              <h3 className="about-1-sub-title"></h3>
              <div className="about-1-text">
                <p className="about-1-quote-1">
                  With over 30 years of experience in framing carpentry, Pedro
                  Zavala has built a career defined by craftsmanship,
                  reliability, and trust. Beginning his journey in his
                  mid-twenties, Pedro has framed everything from modest
                  single-family homes to large custom builds and complex
                  additions. Each project is approached with the same dedication
                  to precision, durability, and detail. Proud of his Mexican
                  heritage and roots in Yuriria, Guanajuato, Pedro combines a
                  strong work ethic with a genuine respect for the families and
                  clients he serves. <br /> <br /> Beyond the job site, Pedro enjoys fishing,
                  playing soccer, and working on his own home. It reminds him that
                  building isn’t just his profession, but a way of life. For
                  clients seeking a framing carpenter with proven experience,
                  integrity, and a personal commitment to quality, Pedro Zavala
                  stands ready to bring visions to life.
                  <br />
                  <br />
                  <p className="about-1-quote"> “Good buildings come from good people, and all problems are
                  solved by good design.”</p>
                  <p className="about-1-quote">- Stephen Gardiner</p>
                </p>
                
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
      <br /> <br />
    </div>
  );
};

export default About;
